import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";

const wardsAdaptor = createEntityAdapter({
    selectId: (entity) => entity.ward_id,
})

const initialWards = wardsAdaptor.getInitialState()

export const extendedApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getcleanerapp: builder.query({
            query: () => `b2g/eco-admin/cleaner`,
            transformResponse: responseData => {
                return responseData?.data;
            },
            providesTags: [
                { type: 'B2gUserApp', id: 'List' }
            ]
        }),
        addNewcleanerapp: builder.mutation({
            query: body => ({
                url: '/b2g/eco-admin/cleaner',
                method: 'POST',
                body: body
            }),
            invalidatesTags: [
                { type: 'B2gUserApp', id: 'List' }
            ]
        }),
        deleteCleanerApp: builder.mutation({
            query: id => ({
                url: `/b2g/eco-admin/cleaner/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [
                { type: 'B2gUserApp', id: 'List' }
            ]
        }),
        editcleanerApp: builder.mutation({
            query: payLoad => ({
                url: `/b2g/eco-admin/cleaner`,
                method: 'PATCH',
                body: payLoad
            }),
            invalidatesTags: [
                { type: 'B2gUserApp', id: 'List' }
            ]
        }),
        getWards: builder.query({
            query: () => '/b2g/eco-admin/address/community/ward',
            transformResponse: responseData => {
                if (responseData?.status === false) {
                    throw new Error(responseData?.statusCode)
                }
                return wardsAdaptor.setAll(initialWards, responseData?.data)
                // return wardsAdaptor.setAll(initialWards, Array.isArray(responseData?.data) ? responseData.data : []);
            },
            providesTags: (result, error, arg) => {
                if (error) {
                    return []
                }
                if (!error && result?.ids) {
                    return [
                        { type: 'Wards', id: "List" },
                        ...result.ids.map(id => ({ type: 'Wards', id }))
                    ]
                }
            }
        })
    })
})

export const {
    useGetcleanerappQuery,
    useAddNewcleanerappMutation,
    useDeleteCleanerAppMutation,
    useEditcleanerAppMutation,
    useGetWardsQuery
} = extendedApiSlice
